import { useCallback, useContext, useEffect } from 'react';
import { ChatbotWidgetContext } from '../utils/ChatbotWidgetContext';
import { fetchCCAIUserToken } from '../utils/fetchCCAIUserToken';
import { View } from '../constants/view';

export const useStartCall = (recordingPermission: boolean): (() => Promise<void>) => {
  const { setView, client, setClient, options, user } =
    useContext(ChatbotWidgetContext);
  const { name, phone } = user;

  const startCall = useCallback(async (): Promise<void> => {
    const { Client } = await import('@ujet/websdk-headless');

    const client = new Client({
      companyId: options.companyId,
      host: options.host,
      authenticate: fetchCCAIUserToken(options.apiUrl, { name, phone })
    });

    setClient(client);
  }, [ name, phone, options, setClient ]);

  useEffect(() => {
    if (!client) return;

    const createCall = async (): Promise<void> => {
      await client.createCall(options.menuId, {
        phone_number: phone,
        recording_permission: recordingPermission
          ? 'recording_permission_granted'
          : 'recording_permission_denied',
        lang: 'en'
      });
      setView(View.CALL_SUBMITTED);
    };

    client.on('ready', () => {
      createCall();
    });

    return (): void => {
      client.off('ready', () => {
        createCall();
      });
    };
  }, [ client, options.menuId, setView ]);

  return startCall;
};
